module.exports = __webpack_public_path__ + "static/media/GR.7831859c.svg";